import axios from "./axios";
import * as Requests from "./requests";

export const getOrderAPI = (token, id) => {
  return axios.get(Requests.orderAPI(id), {
    headers: {
      token,
    },
  });
};
